import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DashboardService } from './dashboard/dashboard.service';
import { ComplaintModel } from './EMR/PrimaryExaminationModels/complaint.model';
import { DiseaseModel } from './EMR/HistoryModels/disease.model';
import { MatDialog } from '@angular/material/dialog';
import { SurgicalHistoryModel } from './EMR/HistoryModels/surgicalhistory.model';
import { DrugAllergyModel } from './EMR/HistoryModels/drugallergy.model';
import { SurgeryDepartmentModel } from './EMR/HistoryModels/surgery_department.model';
import { EyeVisionTypeModel } from './EMR/PrimaryExaminationModels/eyevisiontypes.model';
import { Initial_loaderComponent } from './auth/initial_loader/initial_loader.component';
import { CategoriesModel } from './EMR/HistoryModels/categories.model';
import { TestModel } from './EMR/PrimaryExaminationModels/test.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelplistService {

  tests: TestModel[] = [];

  complaints: ComplaintModel[] = [];
  
  diseaseList: DiseaseModel[] = [];
defaultdiseases: DiseaseModel[] = []; 
surgeryList: SurgicalHistoryModel[] = [];
//druglist: DrugAllergyModel[] = []; 
surgery_departments: SurgeryDepartmentModel[] = [];
eyevisiontypes_SPH: EyeVisionTypeModel[] = [];
eyevisiontypes_CYL: EyeVisionTypeModel[] = [];
eyevisiontypes_AXS: EyeVisionTypeModel[] = [];
eyevisiontypes_VA: EyeVisionTypeModel[] = [];
categories: CategoriesModel[] = [];

public checkGuideTourNumber = 0;
public content =  new BehaviorSubject<string>('1');
public sharedata= this.content.asObservable();
  familyrelation: any;
constructor(public http: HttpClient,
  public dashboardService: DashboardService,
  public dialog: MatDialog) { }


open_loader_Dialog(): void {
  
  const dialogRef = this.dialog.open(Initial_loaderComponent, {
    width: '300px',
    panelClass: 'site-loader',
    data: {
      // id: this.dashboardService.pid,
      //userid: this.authService.Loggeduser.userid
    }
  }); 

  dialogRef.afterClosed().subscribe(result => {
    
    
    // console.log('The dialog was closed');
    //pid = result;
  });
}

fill_help_lists(type){

  this.get_diseaselist(0,0); 
  this.get_surgerylist(0,0);  
 // this.get_druglist(0);
  this.get_surgery_departments();
  this.get_surgery_categories(); 
  this.getcomplaints();
  this.get_tests();


 // SPH
  this.get_eye_vision_types(19); // power
//  CYL
  this.get_eye_vision_types(20); // vision
 // Axis
  this.get_eye_vision_types(23); // axis
  //Relation
  this.get_eye_vision_types(22);
  
  this.get_eye_vision_types(21);
 
}

get_tests(){
  this.http.get<EyeVisionTypeModel>(this.dashboardService.newbaseUrl + "OptoTestMaster/OptoTest").subscribe(
    data => this.success_tests(data), err => this.failed_tests(err)
  )
}
success_tests(data){
this.tests = data;
}

failed_tests(err){
this.dashboardService.openSnackBar("primary examinations test api failed", "OK");
}

get_eye_vision_types(catid: number){
  this.http.get<EyeVisionTypeModel>(this.dashboardService.newbaseUrl + "PopupMaster/getPop/" + catid).subscribe(
    data => this.success_eyevision_types(data,catid), err => this.failed_eyevision_types(err)
  )
}

success_eyevision_types(data, catid: number){
  // sph
 if(catid == 19) {
   this.eyevisiontypes_SPH = data.filter(item=>item.isActive==true);
  //  console.log("sph count " +  this.eyevisiontypes_SPH.length);
 }
 // cyl
 if(catid == 20) {
   this.eyevisiontypes_CYL = data.filter(item=>item.isActive==true);
  //  console.log("cyl count " +  this.eyevisiontypes_CYL.length);
 }
 // axis
 if(catid == 23) {
   this.eyevisiontypes_AXS = data.filter(item=>item.isActive==true);
  //  console.log("axs count " +  this.eyevisiontypes_AXS.length);
 }
 if(catid == 22) {
   this.familyrelation = data.filter(item=>item.isActive==true);
 }
if(catid == 21) {
   this.eyevisiontypes_VA = data.filter(item=>item.isActive==true);
 }
 
    
}

failed_eyevision_types(err){
this.dashboardService.openSnackBar("eye vision helplist api failed ", "OK")
}

get_surgery_categories(){
  this.http.get<any>(this.dashboardService.newbaseUrl + "SurgeryCategoryMaster/Category").subscribe(
     data => this.success_surgery_categories(data), err => this.failed_surgery_categories(err)
  )
   }
   success_surgery_categories(data){
   this.categories = data;
  //  console.log("cat " + this.categories);
   }
 
   failed_surgery_categories(err){
    this.dashboardService.openSnackBar("Surgery Categories Api failed", "OK");
   }


get_surgery_departments(){
  this.http.get<any>(this.dashboardService.newbaseUrl + "SurgeryDeptMaster/Dept").subscribe(
    data => this.success_surgery_departments(data), err => this.failed_surgery_department(err)
  )
  
  }
  success_surgery_departments(data){
  this.surgery_departments = data;
  }

  failed_surgery_department(err){

  }
// getsalthName(type){
//   return  this.http.get<any> (this.dashboardService.newbaseUrl + "SaltMaster/GetAllSalt/"+type);
// }
// get_druglist(type) {
//   this.http.get<any> (this.dashboardService.newbaseUrl + "SaltMaster/GetAllSalt/"+type).subscribe(
//     data => this.success_drugs(data), err => this.fail_drugs(err)
//   )
// }

// success_drugs(data) {

//   this.druglist = data;


// }

// fail_drugs(err) {

// }


get_surgerylist(type,searchtype) {

  // this.open_loader_Dialog();

  this.http.get<any> (this.dashboardService.newbaseUrl + "SurgeryMaster/GetSurgeryAll/"+type +'/'+searchtype).subscribe(
    data => this.success_surgeries(data), err => this.fail_surgeries(err)
  )
}

success_surgeries(data) {
  this.content.next('1'); 
   this.checkGuideTourNumber =1;
  this.surgeryList = data;
  // this.dialog.closeAll();
  

}

fail_surgeries(err) {
  // this.dialog.closeAll();
}

getDiseaseData(type,searchtype ){
  return this.http.get<any> (this.dashboardService.newbaseUrl + "DiseaseMaster/GetDiseaseAll/"+type +'/'+searchtype);
}

get_diseaselist(type,searchtype) {
  this.http.get<any> (this.dashboardService.newbaseUrl + "DiseaseMaster/GetDiseaseAll/"+type+'/'+searchtype).subscribe(
    data => this.success_diseases(data), err => this.fail_diseases(err)
  )
}
success_diseases(data) {

  this.diseaseList = data;
  // console.log ("diseases loaded " + this.diseaseList );

this.defaultdiseases  = this.diseaseList.filter(disease => disease.isDefault === true && disease.isActive ==true);

//console.log ("default count " + this.defaultdiseases.length);
}
fail_diseases(err) {

}



failed_methods(err){

}

   getcomplaints(){
     this.http.get<ComplaintModel>(this.dashboardService.newbaseUrl + "ComplaintCategoryMaster/GetCompCategoryAll").subscribe(

      data => this.successcomplaints(data), err => this.failedcomplaints(err)
     );
   }

   successcomplaints(data){
                 this.complaints = data;
   }

   failedcomplaints(err){
      console.log ("complaints api failed");      
   }

}
 